import type { FaireProductEntity } from "../../entity_types/product";

export const p_e7ffsnbnn9: FaireProductEntity = {
  token: "p_e7ffsnbnn9",
  type: "product",
  name: "Organic Cotton T-Shirt & Short Set",
  brandToken: "b_gr8mfg9fgj",
  brandName: "Arbor Cove",
  imageUrl:
    "https://cdn.faire.com/fastly/9b0be43c3d43287ecb1fda9d9a1db1cb20bc4b0abf4656664f93b9e56ad23d9e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/276e2f4bc1a6d2cc38912f83df939050a093b5521c55ff1066e0417c886f0b45.jpeg",
    "https://cdn.faire.com/fastly/25245f149e0a9afcb25c32aa0b9f4e939b6816455189808376b676814bd435d0.jpeg",
    "https://cdn.faire.com/fastly/409622b763a0ba910176e27011c2dba8c01acc7e8f10460c62bd4da49fca4926.jpeg",
    "https://cdn.faire.com/fastly/0b32c54518f921b3ebd1698f6b9d1edbc11f061b835dbcf003e1f8b83be1dddd.jpeg",
    "https://cdn.faire.com/fastly/f3c8abc992c9d61d85e643b1f9db7c9bf43aeb67e4270192a52d9d8d39cae738.jpeg",
  ],
  priceDollars: 14.4,
  description:
    "Keep your little one cool and comfortable with our Organic Cotton T-Shirt & Short Set, the perfect warm-weather outfit for babies and toddlers. Made from buttery-soft, breathable organic cotton, this set is gentle on delicate skin and ideal for all-day play.\n\nWith a relaxed fit and lightweight feel, it’s designed for easy movement — whether your child is running, climbing, or lounging. The matching tee and shorts create an effortlessly cute look that’s as functional as it is stylish.\n\nAvailable in three versatile colors, this set is a must-have summer staple you’ll reach for again and again.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:04.861Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
